import { render, staticRenderFns } from "./ListView.vue?vue&type=template&id=38abf50d&scoped=true&"
import script from "./ListView.vue?vue&type=script&lang=js&"
export * from "./ListView.vue?vue&type=script&lang=js&"
import style0 from "./ListView.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ListView.vue?vue&type=style&index=1&id=38abf50d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38abf50d",
  null
  
)

export default component.exports